var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterfacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.068,
    height: 27.068,
    viewBox: "0 0 27.068 27.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_021-facebook",
    "data-name": "021-facebook",
    d: "M23.1,0H3.965A3.97,3.97,0,0,0,0,3.965V23.1a3.97,3.97,0,0,0,3.965,3.965h7.983V17.5H8.776V12.741h3.172V9.516a4.763,4.763,0,0,1,4.758-4.758h4.811V9.516H16.706v3.225h4.811L20.724,17.5H16.706v9.569h6.4A3.97,3.97,0,0,0,27.068,23.1V3.965A3.97,3.97,0,0,0,23.1,0Zm0,0",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterfacebook);
export default __webpack_public_path__ + "static/media/footerfacebook.899fae07b69192b4499afc89aaeeb652.svg";
export { ForwardRef as ReactComponent };